<template>
  <AppShell
    brand-name="Write Yo Rep"
    brand-icon="landmark"
    footer-tagline="Physical mail matters. Make your voice heard."
    contact-email="support@writeyorep.com"
    copyright-name="Write Yo Rep"
    :is-logged-in="isLoggedIn"
    @sign-in="handleSignIn"
    @sign-out="handleSignOut"
  >
    <router-view />
  </AppShell>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { AppShell } from '@thinking-of-u/ui';

export default {
  name: 'App',
  components: { AppShell },
  computed: {
    ...mapGetters(['isLoggedIn']),
  },
  methods: {
    ...mapActions(['signInWithGoogle', 'signOut']),
    async handleSignIn() {
      try {
        await this.signInWithGoogle();
        // Check for redirect query param
        const redirect = this.$route.query.redirect;
        if (redirect) {
          this.$router.push(redirect);
        }
      } catch (error) {
        console.error('Sign in failed:', error);
      }
    },
    async handleSignOut() {
      await this.signOut();
      this.$router.push('/');
    },
  },
};
</script>
